import { NetworkCalls } from "../../../NetworkCalls";
import { useMutation } from "@tanstack/react-query";
import { Button } from "react-bootstrap";
import { useEffect } from "react";

export default function WaterImageUpload({
                                             afterSuccess,
                                             waterId
                                         }: {
    afterSuccess: () => void,
    waterId: string
}) {

    const mutation = useMutation({
        mutationFn: async (files: any) => NetworkCalls.uploadImage(files[0], waterId),
        onSuccess: async () => afterSuccess(),
    });

    useEffect(() => {
        const timer = setTimeout(() => {
            mutation.reset();
        }, 3000);

        return () => clearTimeout(timer);
    }, [mutation, waterId]);

    return <>
        {mutation.isPending ? (<Button variant={'primary'} className={'btn-loading'}> Lade hoch... </Button>) :
            <>
                {mutation.isError ? (<> Fehler beim Hochladen: {mutation.error.message} </>) : null}
                {mutation.isSuccess ? (<> Erfolgreich hochgeladen </>) : null}
                <label className="btn btn-primary ms-auto" style={{cursor: "pointer"}}>
                    <input type="file" style={{display: "none"}}
                           onChange={e => mutation.mutate(e.target.files)} accept="image/*"/>
                    Bild hochladen
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="icon icon-tabler icon-tabler-plus ms-2"
                        width="44"
                        height="44"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="#ffffff"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M12 5l0 14"/>
                        <path d="M5 12l14 0"/>
                    </svg>
                </label>
            </>}
    </>;
}
